const toFetchIDValue = (item, dataValue) => {


    let returnID = "";
    let itemObject = {};

    let IDTYPE = {
        "SINGAPORE CITIZEN": "SP",
        "SINGAPORE PERMANENT RESIDENT": "SB",
        "FOREIGNER (PASSPORT)": "PP"
    }
    let countries = {
        "SINGAPORE": "SG",
        "MALAYSIA": "MY",
        "ANDORRA": "AD",
        "UNITED ARAB EMIRATES": "AE",
        "AFGHANISTAN": "AF",
        "ANTIGUA AND BARBUDA": "AG",
        "ANGUILLA": "AI",
        "ALBANIA": "AL",
        "ARMENIA": "AM",
        "NETHERLANDS ANTILLES": "AN",
        "ANGOLA": "AO",
        "ARGENTINA": "AR",
        "AMERICAN SAMOA": "AS",
        "AUSTRIA": "AT",
        "AUSTRALIA": "AU",
        "ARUBA": "AW",
        "AZERBAIJAN": "AZ",
        "BOSNIA-HERZEGOVINA": "BA",
        "BARBADOS": "BB",
        "BANGLADESH": "BD",
        "BELGIUM": "BE",
        "BURKINA FASO": "BF",
        "BULGARIA": "BG",
        "BAHRAIN": "BH",
        "BURUNDI": "BI",
        "BENIN": "BJ",
        "BERMUDA": "BM",
        "BRUNEI DARUSSALAM": "BN",
        "BOLIVIA": "BO",
        "BRAZIL": "BR",
        "BAHAMAS": "BS",
        "BHUTAN": "BT",
        "MYANMAR": "BU",
        "BOUVET ISLAND": "BV",
        "BOTSWANA": "BW",
        "BELARUS": "BY",
        "BELIZE": "BZ",
        "CANADA": "CA",
        "COCOS (KEELING) ISLANDS": "CC",
        "CENTRAL AFRICAN REP": "CF",
        "CONGO": "CG",
        "SWITZERLAND": "CH",
        "COTE D'IVOIRE (IVORY COAST)": "CI",
        "COOK IS": "CK",
        "CHILE": "CL",
        "CAMERON": "CM",
        "CHINA": "CN",
        "COLOMBIA": "CO",
        "COSTA RICA": "CR",
        "CUBA": "CU",
        "CAPE VERDE": "CV",
        "CHRISTMAS IS": "CX",
        "CYPRUS": "CY",
        "CZECH REPUBLIC": "CZ",
        "GERMANY": "DE",
        "DJIBOUTI": "DJ",
        "DENMARK": "DK",
        "DOMINICA": "DM",
        "DOMINICAN REPUBLIC": "DO",
        "ALGERIA": "DZ",
        "ECUADOR": "EC",
        "ESTONIA": "EE",
        "EGYPT": "EG",
        "WESTERN SAHARA": "EH",
        "SPAIN": "ES",
        "ETHIOPIA": "ET",
        "FINLAND": "FI",
        "FIJI": "FJ",
        "FALKLAND ISLANDS (MALVINAS)": "FK",
        "MICRONESIA, FEDERATED STATES OF": "FM",
        "FAROE ISLANDS": "FO",
        "FRANCE": "FR",
        "GABON": "GA",
        "UNITED KINGDOM": "GB",
        "GRENADA": "GD",
        "FRENCH GUIANA": "GF",
        "GUERNSEY": "GG",
        "GHANA": "GH",
        "GIBRALTAR": "GI",
        "GREENLAND": "GL",
        "GAMBIA": "GM",
        "GUINEA": "GN",
        "GUADELOUPE": "GP",
        "EQUATORIAL GUINEA": "GQ",
        "GREECE": "GR",
        "GUATEMALA": "GT",
        "GUAM": "GU",
        "GUINEA-BISSAU": "GW",
        "GUYANA": "GY",
        "HONGKONG": "HK",
        "HEARD AND MCDONALD ISLASNDS": "HM",
        "HONDURAS": "HN",
        "CROATIA": "HR",
        "HAITI": "HT",
        "HUNGARY": "HU",
        "INDONESIA": "ID",
        "IRELAND": "IE",
        "ISRAEL": "IL",
        "ISLE OF MAN": "IM",
        "INDIA": "IN",
        "BRITISH INDIAN OCEAN TERRITORY": "IO",
        "IRAQ": "IQ",
        "IRAN, ISLAMIC REPUBLIC OF": "IR",
        "ICELAND": "IS",
        "ITALY": "IT ",
        "JERSEY": "JE ",
        "JAMAICA": "JM ",
        "JORDAN": "JO ",
        "JAPAN": "JP ",
        "JERSEY": "JS ",
        "KENYA": "KE ",
        "KYRGYZSTAN": "KG ",
        "CAMBODIA": "KH ",
        "KIRIBATI": "KI ",
        "KAZAKHSTAN": "KK ",
        "COMOROS": "KM ",
        "SAINT KITTS-NEVIS": "KN ",
        "KOREA, DEMOCRATIC PEOPLE REPUBLIC OF (NORTH)": "KP ",
        "KOREA, REPUBLIC OF": "KR ",
        "KUWAIT": "KW ",
        "CAYMAN IS": "KY ",
        "LAO PEOPLE'S DEMOCRATIC REPUBLIC": "LA ",
        "LEBANON": "LB ",
        "SAINT LUCIA": "LC ",
        "LIECHSTENSTEIN": "LI ",
        "SRI LANKA": "LK ",
        "LIBERIA": "LR ",
        "LESOTHO": "LS ",
        "LITHUANIA": "LT ",
        "LUXEMBOURG": "LU ",
        "LATVIA": "LV ",
        "LIBYAN ARAB JAMAHIRIYA": "LY ",
        "MOROCCO": "MA ",
        "MONACO": "MC ",
        "MOLDOVA, REPUBLIC OF": "MD ",
        "MADAGASCAR": "MG ",
        "MARSHALL IS": "MH ",
        "MALI": "ML ",
        "MONGOLIA": "MN",
        "MACAO": "MO",
        "NORTHERN MARIANA IS": "MP",
        "MARTINIQUE": "MQ",
        "MAURITANIA": "MR",
        "MONTSERRAT": "MS",
        "MALTA": "MT",
        "MAURITIUS": "MU",
        "MALDIVES": "MV",
        "MALAWI": "MW",
        "MEXICO": "MX",

        "MOZAMBIQUE": "MZ",
        "NAMIBIA": "NA",
        "NEW CALEDONIA": "NC",
        "NIGER": "NE",
        "NORFOLK ISLAND": "NF",
        "NIGERIA": "NG",
        "NICARAGUA": "NI",
        "NETHERLANDS": "NL",
        "NORWAY": "NO",
        "NEPAL": "NP",
        "NAURU": "NR",
        "NIUE": "NU",
        "NEW ZEALAND": "NZ",
        "OMAN": "OM",
        "PANAMA": "PA",
        "PERU": "PE",
        "FRENCH POLYNESIA": "PF",
        "PAPUA NEW GUINEA": "PG",
        "PHILIPPINES": "PH",
        "PAKISTAN": "PK",
        "POLAND": "PL",
        "SAINT PIERRE AND MIQUELON": "PM",
        "PITCAIRN": "PN",
        "PUERTO RICO": "PR",
        "PALESTINIAN TERRITORY, OCCUPIED": "PS",
        "PORTUGAL": "PT",
        "PALAU": "PW",
        "PARAGUAY": "PY",
        "QATAR": "QA",
        "REUNION": "RE",
        "ROMANIA": "RO",
        "RUSSIAN FEDERATION": "RU",
        "RWANDA": "RW",
        "SAUDI ARABIA": "SA",
        "SOLOMAN IS": "SB",
        "SEYCHELLES": "SC",
        "SUDAN": "SD",
        "SWEDEN": "SE",

        "ST HELENA": "SH",
        "SLOVENIA": "SI",
        "SVALBARD AND JAN MAYEN IS": "SJ",
        "SLOVAKIA": "SK",
        "SIERRA LEONE": "SL",
        "SAN MARINO": "SM",
        "SENEGAL": "SN",
        "SOMALIA": "SO",
        "SURINAME": "SR",
        "SOUTH SUDAN": "SS",
        "SAO TOME AND PRINCIPE": "ST",
        "EL SALVADOR": "SV",
        "SYRIAN ARAB REPUBLIC (SYRIA)": "SY",
        "SWAZILAND": "SZ",
        "TURKS AND CAICOS IS": "TC",
        "CHAD": "TD",
        "FRENCH SOUTHERN TERRITORIES": "TF",
        "TOGO": "TG",
        "THAILAND": "TH",
        "TAJIKISTAN": "TJ",
        "TURKMENISTAN": "TM",
        "TUNISIA": "TN",
        "TONGA": "TO",
        "EAST TIMOR": "TP",
        "TURKEY": "TR",
        "TRINIDAD AND TOBAGO": "TT",
        "TUVALU": "TV",
        "TAIWAN, PROVINCE OF CHINA": "TW",
        "TANZANIA, UNITED REPUBLIC OF": "TZ",
        "UKRAINE": "UA",
        "UGANDA": "UG",
        "UNITED STATES MINOR OUTLYING ISLANDS": "UM",
        "UNITED STATES OF AMERICA": "US",
        "URUGUAY": "UY",
        "UZBEKISTAN": "UZ",
        "HOLY SEE (VATICAN CITY STATE)": "VA",
        "SAINT VINCENT AND THE GRENADINES": "VC",
        "VENEZUELA": "VE",
        "VIRGIN ISLANDS, BRITISH": "VG",
        "VIRGIN ISLANDS (US)": "VI",
        "VIET NAM": "VN",
        "VANUATU": "VU",
        "WALLIS AND FUTUNA": "WF",
        "SAMOA": "WS",
        "YEMEN PEOPLE'S DEMOCRATIC REPUBLIC": "YD",
        "YEMEN": "YE",
        "MAYOTTE": "YT",
        "YUGOSLAVIA": "YU",
        "SOUTH AFRICA": "ZA",
        "ZAMBIA": "ZM",
        "ZAIRE": "ZR",
        "ZIMBABWE": "ZW",
        "ALAND ISLANDS": "AX",
        "ANTARCTICA": "AQ",
        "ONGO, THE DEMOCRATIC REPUBLIC OF THE": "CD",
        "ERITREA": "ER",
        "MACEDONIA, THE FORMER YUGOSLAV REPUBLIC OF": "MK",
        "MONTENEGRO": "ME",
        "SAINT BARTHÉLEMY": "BL",
        "SAINT MARTIN": "MF",
        "SERBIA": "RS",
        "SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS": "GS",
        "TIMOR-LESTE": "TL",
        "GEORGIA": "GE",
        "KAZAKHSTAN": "KZ",
        "MYANMAR (BURMA)": "MM",
        "STATELESS": "ZZ",
        "CURACAO": "CW",
        "KOSOVO": "XK",
        "CARRIBBEAN NETHERLANDS": "BQ"



    }

    let BANKDATALIST = {
        "DBS": "7171",
        "OCBC": "7339",
        "UOB": "7375",
        "CITIBANK NA": "7214",
        "Citibank Singapore Limited": "9201",
        // "HSBC": "7232",  // for CR - Pre login FT changes Apr 2023.docx
        "HSBC Bank (Singapore) Limited": "9548",
        // "Standard Chartered Bank": "7144", // for CR - Pre login FT changes Apr 2023.docx
        "Standard Chartered Bank Singapore Limited": "9496",
        "AMEX": "7454",
        "ABSA Bank Ltd": "8828",
        "ANZ Banking Group": "7931",
        "Arab Bank PLC": "8253",
        "Arab Banking Corporation BSC": "8217",
        "Banca Monte dei Paschi di Siena S.p.A.": "8411",
        "Bangkok Bank Public Company Ltd": "7047",
        "BANK OF AMERICA NA": "7065",
        "BANK OF CHINA LTD": "7083",
        "Bank of Communications": "8916",
        "Bank of East Asia Ltd": "7092",
        "Bank of India": "7108",
        "Bank of New Zealand": "8129",
        "Bank of Nova Scotia": "7658",
        "BANK OF TAIWAN": "8846",
        "BARCLAYS BANK PLC": "7533",
        "Bayerische Hypo-Und Vereinsbank": "8855",
        "BNP Paribas": "7418",
        "BNP PARIBAS SECURITIES SERVICES": "9344",
        "Chang Hwa Commercial Bank Ltd": "9025",
        "China CITIC Bank International Ltd": "9423",
        "China Construction Bank": "9043",
        "CIMB Bank Berhad": "7986",
        "CLS BANK INTERNATIONAL": "9991",
        "Commerzbank Aktiengesellschaft": "8606",
        "Credit Agricole Corporate & Investment Bank-SG BR": "7135",
        "CREDIT INDUSTRIEL ET COMMERCIAL": "8299",
        "CREDIT SUISSE AG": "7481",
        "CTBC Bank Co., Ltd": "9353",
        "Deutsche Bank AG": "7463",
        "Dexia Banque International a Luxembourg": "8581",
        "Diners Club": "1111",
        "DNB Bank ASA": "7737",
        "Dresdner Bank AG": "7393",
        "Far Eastern Bank Ltd": "7199",
        "First Commercial Bank, Ltd": "7764",
        "Fleet National Bank - Head Office": "7843",
        "Habib Bank Ltd": "7409",
        "HL Bank": "7287",
        "Hong Leong Finance Ltd": "5027",
        "Hua Nan Commercial Bank, Ltd": "8864",
        "ICB": "7269",
        "ICICI Bank Limited": "9186",
        "Indian Bank": "7241",
        "INDIAN OVERSEAS BANK": "7250",
        "Industrial & Commercial Bank of China": "8712",
        "ING BANK NV": "8509",
        "Intesa Sanpaolo S.p.A.": "8350",
        "JPMorgan Chase Bank N.A.": "7153",
        "KBC Bank N.V.": "8703",
        "KEB HANA BANK": "7490",
        "Krung Thai Bank PCL": "8785",
        "LANDESBANK BADEN-WURTTEMBERG": "8873",
        "MACQUARIE BANK LIMITED": "9432",
        "Mega Intl Commercial Bank Co., Ltd": "8235",
        "Mizuho Bank, Ltd": "7621",
        "MUFG BANK LTD, SINGAPORE BRANCH": "7126",
        "Natexis Banques Popularies": "8156",
        "National Australia Bank Limited": "8077",
        "NATWEST MARKETS PLC": "7010",
        "Nordea Bank Finland Plc": "8518",
        "OUB": "7348",
        "P.T. Bank Mandiri (Persero)": "8749",
        "Philippine National Bank - Cecil Street": "7870",
        "PT BANK NEGARA INDONESIA (PERSERO)": "7056",
        "Rabobank": "8439",
        "Raiffeisen Zentralbank Osterreich AG": "9034",
        "RHB Bank Berhad": "7366",
        "ROYAL BANK OF CANADA": "7667",
        "SHINHAN BANK": "8615",
        "Singapore Island Bank Ltd": "7117",
        "Skandinaviska Enskilda Banken AB": "8527",
        "Societe Generale - Singapore Branch": "7852",
        "Southern Bank Berhad": "7038",
        "State Bank of India": "7791",
        "Sumitomo Mitsui Banking Corporation": "7472",
        "Svenska Handelsbanken AB (publ)": "8493",
        "The Agricultural Bank of China": "8837",
        "The Bank of Taiwan": "8846",
        "The Korea Development Bank": "8934",
        "The National Bank of Kuwait SAK": "8280",
        "The Norinchukin Bank": "8688",
        "The Siam Commercial Bank PCL": "8800",
        "TORONTO-DOMINION BANK": "8882",
        "TRUST BANK SINGAPORE LIMITED": "9733",
        "UBS AG": "7685",
        "UCO Bank": "7357",
        "UFJ Bank Ltd - Singapore Branch": "7807",
        "Union de Banques Arabes et Francaises": "8110",
        "VTB Capital Plc": "7427",
        "Westpac Banking Corporation": "7889",
        "Woori Bank": "7995"
    }
    // FT Pre login – Pre login FT changes Apr 2023.docx
    let PRICINGPROMO = {
        "0% p.a. for 6 months with 2.28% processing fee (EIR at 4.87% p.a.) and prevailing interest rate applies thereafter (min $1,000)": "U",
        "0% p.a. for for 12 months 4.38% processing fee (EIR at 5.06% p.a.), and prevailing interest rate applies thereafter (min S$1,000)": "Y"
    }

    let PRICINGCAFTSCHME = {
        "0% p.a. for 6 months with 2.28% processing fee (EIR at 4.87% p.a.) and prevailing interest rate applies thereafter (min $1,000)": "FT2086",
        "0% p.a. for for 12 months 4.38% processing fee (EIR at 5.06% p.a.), and prevailing interest rate applies thereafter (min S$1,000)": "FT2082"
    }



    //APRIL 15th 2024

    let PRICINGPROMOHNW = {
        "0% p.a. for 6 months with 1.48% processing fee (EIR at 3.17% p.a.),  prevailing interest rate applies thereafter (min S$2,000)": "W",
        "0% p.a. for 12 months 3.88% processing fee (EIR at 4.49% p.a.), prevailing interest rate applies thereafter (min S$ 2,000) *Be awarded with an automatic Ingersoll timepiece worth $358 with minimum approved Funds Transfer amount of S$10,000": "T",

    }

    let PRICINGSCHMEHNW = {
        "0% p.a. for 6 months with 1.48% processing fee (EIR at 3.17% p.a.),  prevailing interest rate applies thereafter (min S$2,000)": "FT148F",
        "0% p.a. for 12 months 3.88% processing fee (EIR at 4.49% p.a.), prevailing interest rate applies thereafter (min S$ 2,000) *Be awarded with an automatic Ingersoll timepiece worth $358 with minimum approved Funds Transfer amount of S$10,000": "FT388F",

    }

    //SEPT 7th New

    // let PRICINGPROMOHNW = {
    //     "0% p.a. for 6 months with 2.68% processing fee (EIR at 5.72% p.a.), prevailing interest rate applies thereafter (min S$2,000)": "W",
    //     "0% p.a. for 12 months 4.68% processing fee (EIR at 5.40% p.a.), prevailing interest rate applies thereafter (min S$2,000)": "T"
    // }

    // let PRICINGSCHMEHNW = {
    //     "0% p.a. for 6 months with 2.68% processing fee (EIR at 5.72% p.a.), prevailing interest rate applies thereafter (min S$2,000)": "FT268F",
    //     "0% p.a. for 12 months 4.68% processing fee (EIR at 5.40% p.a.), prevailing interest rate applies thereafter (min S$2,000)": "FT468F"
    // }

    //end by Sept 22nd 2023
    // let PRICINGPROMOHNW = {
    //     "0% p.a. for 6 months with 0.99% processing fee (EIR at 2.13% p.a.) and prevailing interest rate applies thereafter (min $2,000)": "W",
    //     "0% p.a. for for 12 months 1.28% processing fee (EIR at 1.50% p.a.), and prevailing interest rate applies thereafter (min S$2,000)": "T"
    // }

    // let PRICINGSCHMEHNW = {
    //     "0% p.a. for 6 months with 0.99% processing fee (EIR at 2.13% p.a.) and prevailing interest rate applies thereafter (min $2,000)": "FT099F",
    //     "0% p.a. for for 12 months 1.28% processing fee (EIR at 1.50% p.a.), and prevailing interest rate applies thereafter (min S$2,000)": "FT128C"
    // }

    //APR 2024

    let PRICINGPROMOMBANKOUTSIDERS = {
        "2.50% p.a. for 6 months with 0% processing fee, prevailing interest rate applies thereafter (min S$2,000)": "X",

    }

    let PRICINGSCHMEMBANKOUTSIDERS = {
        "2.50% p.a. for 6 months with 0% processing fee, prevailing interest rate applies thereafter (min S$2,000)": "FT250R",

    }


    //Before APR 2024
    // let PRICINGPROMOMBANKOUTSIDERS = {
    //     "2.48% p.a. for 6 months, prevailing interest rate applies thereafter (min S$2,000)": "X",
    //     "3.48% p.a. for 12 months, prevailing interest rate applies thereafter (min S$2,000)": "M"
    // }

    // let PRICINGSCHMEMBANKOUTSIDERS = {
    //     "2.48% p.a. for 6 months, prevailing interest rate applies thereafter (min S$2,000)": "FT248R",
    //     "3.48% p.a. for 12 months, prevailing interest rate applies thereafter (min S$2,000)": "FT348R"
    // }




    //FT Pre login – 2022 Year End Arbutus FT campaign for the period 20 Oct 2022 ~ 17 Jan 2023
    // let PRICINGPROMO = {
    //     "0% p.a for 6 months with 1.38% processing fee (EIR at 2.96% p.a.) and prevailing interest rate applies thereafter (receive an elegant Arbutus Automatic Timepiece  with minimum approved amount of S$10,000)": "U",
    //     "0% p.a for 6 months with 1.38% processing fee (EIR at 2.96% p.a.) and prevailing interest rate applies thereafter (min S$2,000)": "U",
    //     "4.99% p.a interest for 12 months, prevailing interest rate applies thereafter (min S$2,000)": "Y"
    // }

    // let PRICINGCAFTSCHME = {
    //     "0% p.a for 6 months with 1.38% processing fee (EIR at 2.96% p.a.) and prevailing interest rate applies thereafter (receive an elegant Arbutus Automatic Timepiece  with minimum approved amount of S$10,000)": "FT138F",
    //     "0% p.a for 6 months with 1.38% processing fee (EIR at 2.96% p.a.) and prevailing interest rate applies thereafter (min S$2,000)": "FT138F",
    //     "4.99% p.a interest for 12 months, prevailing interest rate applies thereafter (min S$2,000)": "FT499R"
    // }
    //end promotion by oct 20
    // let PRICINGPROMO = {
    //     "0% for 6 months with 0.99% processing fee (EIR 2.13%) and prevailing interest rate applies thereafter (min S$2,000)": "W",
    //     "0% for 12 months with 1.68% processing fee (EIR 1.96%) and prevailing interest rate applies thereafter (min S$2,000)": "T"
    // }
    // let PRICINGCAFTSCHME = {
    //     "0% for 6 months with 0.99% processing fee (EIR 2.13%) and prevailing interest rate applies thereafter (min S$2,000)": "FT099F",
    //     "0% for 12 months with 1.68% processing fee (EIR 1.96%) and prevailing interest rate applies thereafter (min S$2,000)": "FT168F"
    // }
    //end promotion by oct 20


    // let PRICINGPROMO = {
    //     "0% for 3 months with 1.28% processing fee (EIR 5.26%) and prevailing interest rate applies thereafter (min S$1,000)":"R",
    //     "0% for 6 months with 2.28% processing fee (EIR 4.87%) and prevailing interest rate applies thereafter (min S$1,000)":"S",
    //     "4.99% p.a. for 12 months and prevailing interest rate applies thereafter (min S$1,000)":"V"
    //  }
    // let PRICINGCAFTSCHME = {
    //     "0% for 3 months with 1.28% processing fee (EIR 5.26%) and prevailing interest rate applies thereafter (min S$1,000)":"FT128F",
    //     "0% for 6 months with 2.28% processing fee (EIR 4.87%) and prevailing interest rate applies thereafter (min S$1,000)":"FT228F",
    //     "4.99% p.a. for 12 months and prevailing interest rate applies thereafter (min S$1,000)":"FT499R"
    //  }

    switch (item.toUpperCase()) {
        case "IDTYPE":
            itemObject = IDTYPE;
            break;
        case "COUNTRIES":
            itemObject = countries;
            break;
        case "PRICINGPROMO":
            itemObject = PRICINGPROMO;
            break;
        case "PRICINGCAFTSCHME":
            itemObject = PRICINGCAFTSCHME;
            break;
        case "BANKDATALIST":
            itemObject = BANKDATALIST;
            break;
        case "PRICINGPROMOHNW":
            itemObject = PRICINGPROMOHNW;
            break;
        case "PRICINGSCHMEHNW":
            itemObject = PRICINGSCHMEHNW;
            break;
        case "PRICINGPROMOMBANKOUTSIDERS":
            itemObject = PRICINGPROMOMBANKOUTSIDERS;
            break;
        case "PRICINGSCHMEMBANKOUTSIDERS":
            itemObject = PRICINGSCHMEMBANKOUTSIDERS;
            break;

        default:
            break;
    }

    Object.keys(itemObject).map(function (key) {
        if (dataValue === key) {
            returnID = itemObject[key];
        }
    });

    return returnID;
}

export default toFetchIDValue